(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["barra-beneficios-minimal"] && !Shopify.designMode) return;
  try {
    
  class BarraMinRotator extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.barra-min__item'));
      if (this.items.length < 2 || !this.closest('.barra-min--mobile-rotate')) return;

      this.mediaQuery = window.matchMedia('(max-width: 749px)');
      this.onChange = () => this.sync();
      this.mediaQuery.addEventListener('change', this.onChange);
      this.sync();
    }

    disconnectedCallback() {
      this.stop();
      if (this.mediaQuery) this.mediaQuery.removeEventListener('change', this.onChange);
    }

    sync() {
      if (this.mediaQuery.matches) {
        this.start();
      } else {
        this.stop();
      }
    }

    start() {
      if (this.timer) return;
      this.index = 0;
      this.dataset.rotating = '';
      this.render();
      const interval = parseInt(this.dataset.interval, 10) || 4000;
      this.timer = setInterval(() => {
        this.index = (this.index + 1) % this.items.length;
        this.render();
      }, interval);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
      delete this.dataset.rotating;
      this.items.forEach((item) => item.classList.remove('is-active'));
    }

    render() {
      this.items.forEach((item, i) => item.classList.toggle('is-active', i === this.index));
    }
  }

  if (!customElements.get('barra-min-rotator')) {
    customElements.define('barra-min-rotator', BarraMinRotator);
  }

  } catch(e) { console.error(e); }
})();
})();
